export class ContainersReq{
    enquiryId:number
    confirmedContainersInfo : ConfirmedContainersReq[]
    createdUser:string

    constructor(enquiryId:number,confirmedContainersInfo : ConfirmedContainersReq[],createdUser:string){
        this.enquiryId = enquiryId
        this.confirmedContainersInfo = confirmedContainersInfo
        this.createdUser = createdUser
    }
}

export class ConfirmedContainersReq{
    enquiryProductId: number
    confirmedContainers:number

    constructor(enquiryProductId:number,confirmedContainers:number){
        this.enquiryProductId = enquiryProductId
        this.confirmedContainers = confirmedContainers
    }
}